import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { get } from 'lodash'
import { OperationType } from '../Type/OperationType'
import { UserAPIAdapter } from '../../../admin/vue/adapters/UserAPIAdapter'
import Operation from '../Classes/ClvrOperation'
import { PatientAPIAdapter } from '../../../dPpatients/vue/Adapter/PatientAPIAdapter'
import { OperationDto } from '../Type/OperationDto'
import { AnesthesiaTypeApiAdapter } from './AnesthesiaTypeApiAdapter'
import ResourceType from '../../../dPbloc/vue/Classes/ClvrResourceType'
import { StayApiAdapter } from './StayApiAdapter'
import { RoomApiAdapter } from '../../../dPbloc/vue/Adapters/RoomApiAdapter'
import Staff from '../../../dPpersonnel/vue/Classes/Staff'

export class OperationApiAdapter implements ApiDataAdapter<Operation> {
    public createClass(apiData: OperationDto): Operation {
        const patient = get(apiData, '_ref_patient')
        const surgeon = get(apiData, '_ref_chir')
        const anesthetist = get(apiData, '_ref_anesth')
        const additionalMaterials = get(apiData, '_refs_materiels_operatoires')
        const anesthesiaType = get(apiData, '_ref_type_anesth')
        const stay = get(apiData, '_ref_sejour')
        const room = get(apiData, '_ref_salle')
        const staffs = get(apiData, '_ref_personals')

        const data: OperationType = {
            id: get(apiData, 'id'),
            surgeonId: get(apiData, 'chir_id'),
            stayId: get(apiData, 'sejour_id'),
            roomId: get(apiData, 'salle_id'),
            date: get(apiData, 'date'),
            startOperation: get(apiData, 'time_operation'),
            timeOperation: get(apiData, 'temp_operation'),
            label: get(apiData, 'libelle'),
            materials: get(apiData, 'materiel'),
            remarks: get(apiData, 'rques'),
            additionalMaterials: ResourceType.convertDtoToResourceTypeList(additionalMaterials),
            operationTimeStatus: get(apiData, '_operationTimeStatus'),
            emergency: get(apiData, 'urgence'),
            cancelled: get(apiData, 'annulee'),
        }

        const operation = new Operation(data)
        if (patient) {
            operation.patient = new PatientAPIAdapter().createClass(patient)
        }
        if (surgeon) {
            operation.surgeon = new UserAPIAdapter().createClass(surgeon)
        }
        if (stay) {
            operation.stay = new StayApiAdapter().createClass(stay)
        }
        if (room) {
            operation.room = new RoomApiAdapter().createClass(room)
        }
        if (anesthetist) {
            operation.anesthetist = new UserAPIAdapter().createClass(anesthetist)
        }
        if (anesthesiaType) {
            operation.anesthesiaType = new AnesthesiaTypeApiAdapter().createClass(anesthesiaType)
        }
        if (staffs) {
            operation.staffs = Staff.convertDtoToStaffList(staffs)
        }
        return operation
    }
}
